import { LIGHT_THEME_ID } from './themeIds';

// Backstage's AppThemeSelector persists the chosen theme id under this
// localStorage key; when it is empty, Backstage falls back to the OS
// color-scheme. This constant tracks that internal contract.
const THEME_STORAGE_KEY = 'theme';

// One-time marker so we seed the default exactly once per browser.
const DEFAULT_APPLIED_KEY = 'launchpad.theme-default-applied';

/**
 * Seeds Light as the theme for brand-new visitors, exactly once.
 *
 * We want first-time users on Light regardless of their OS appearance, but we
 * must NOT re-seed on every empty-key load: choosing "Auto" in settings clears
 * the key, and re-seeding would silently revert that choice to Light on the
 * next reload. The one-time flag distinguishes "first ever visit" from "user
 * deliberately chose Auto".
 *
 * Must run before createApp() constructs the theme selector.
 */
export function applyDefaultThemePreference(): void {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  const storage = window.localStorage;
  if (storage.getItem(DEFAULT_APPLIED_KEY) !== null) {
    return;
  }

  storage.setItem(DEFAULT_APPLIED_KEY, 'true');
  if (storage.getItem(THEME_STORAGE_KEY) === null) {
    storage.setItem(THEME_STORAGE_KEY, LIGHT_THEME_ID);
  }
}
